import { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { motion, AnimatePresence } from "framer-motion";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const navLinks = [
    { to: "home", label: "Home" },
    { to: "uber-uns", label: "Über uns" },
    { to: "dienstleistungen", label: "Dienstleistungen" },
    { to: "footer", label: "Kontakt" },
  ];

  return (
    <nav
      className={`max-w-screen flex justify-between items-center sticky top-0 z-50 bg-white transition-shadow duration-300 ${
        scrolled ? "shadow-md" : ""
      }`}
    >
      <div className="p-4 ml-16 font-bold max-md:ml-4">
        <Link to="home" smooth={true} duration={500} className="cursor-pointer">
          <img className="h-[3em]" src="./Logo.png" alt="Global Bau Logo" />
        </Link>
      </div>

      {/* Desktop Navigation */}
      <div className="hidden md:flex mr-16">
        <ul className="flex gap-8 items-center">
          {navLinks.map((link, i) => (
            <motion.li
              key={link.to}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: i * 0.1 }}
              className="cursor-pointer"
            >
              <Link
                className="text-darkBlue font-medium hover:text-blue-500 transition-colors duration-300 relative after:content-[''] after:absolute after:w-0 after:h-[2px] after:bg-darkBlue after:left-0 after:-bottom-1 after:transition-all after:duration-300 hover:after:w-full"
                to={link.to}
                smooth={true}
                duration={500}
                spy={true}
                activeClass="text-blue-500 after:w-full"
              >
                {link.label}
              </Link>
            </motion.li>
          ))}
        </ul>
      </div>

      {/* Mobile Hamburger */}
      <div
        className="md:hidden p-4 cursor-pointer z-50"
        onClick={toggleMenu}
      >
        <div className="w-6 h-5 relative flex flex-col justify-between">
          <motion.span
            animate={isOpen ? { rotate: 45, y: 8 } : { rotate: 0, y: 0 }}
            className="w-full h-[2px] bg-darkBlue block origin-center"
            transition={{ duration: 0.3 }}
          />
          <motion.span
            animate={isOpen ? { opacity: 0 } : { opacity: 1 }}
            className="w-full h-[2px] bg-darkBlue block"
            transition={{ duration: 0.3 }}
          />
          <motion.span
            animate={isOpen ? { rotate: -45, y: -10 } : { rotate: 0, y: 0 }}
            className="w-full h-[2px] bg-darkBlue block origin-center"
            transition={{ duration: 0.3 }}
          />
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, x: "100%" }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: "100%" }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="fixed inset-0 bg-white z-40 flex items-center justify-center md:hidden"
          >
            <ul className="flex flex-col gap-8 text-center">
              {navLinks.map((link, i) => (
                <motion.li
                  key={link.to}
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3, delay: i * 0.1 }}
                  className="cursor-pointer"
                >
                  <Link
                    className="text-darkBlue text-3xl font-semibold hover:text-blue-500 transition-colors"
                    to={link.to}
                    smooth={true}
                    duration={500}
                    onClick={() => setIsOpen(false)}
                  >
                    {link.label}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
